import { Box, BoxProps, Button } from '@ytl/common-web';
import { useMemo } from 'react';
import { ReactComponent as CheckIcon } from '../../../assets/check.svg';
import { useLanguage } from '../../../contexts/languageContext';

export const useMfaAuthenticatorSuccessView = (email: string, onContinue: () => void) => {
  const { translation } = useLanguage();

  const boxConfig: Omit<BoxProps, 'children'> = useMemo(() => {
    return {
      icon: <CheckIcon className={'icon '} />,
      header: translation.accountSettings.mfa.authenticatorSuccess.title,
      subHeader: (
        <span
          dangerouslySetInnerHTML={{ __html: translation.accountSettings.mfa.authenticatorSuccess.content(email) }}
        />
      ),
      action: (
        <Button onClick={() => onContinue()}>{translation.accountSettings.mfa.authenticatorSuccess.continue}</Button>
      ),
    };
  }, [translation, email, onContinue]);

  const view = useMemo(() => <Box {...boxConfig} />, [boxConfig]);

  return {
    view,
  };
};
